export default __webpack_public_path__ + "694deb4c5f3ed09db39892cf8b0d6d5e.png";